// src/hooks/useBookmark.js
import { useState, useEffect } from 'react';
import { useUIFeedback } from '../components/UIFeedback';

const useBookmark = (effectiveUserId, basePageName) => {
  const { showToast } = useUIFeedback();
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [bookmarkedValue, setBookmarkedValue] = useState(null);

  useEffect(() => {
    if (!effectiveUserId || !basePageName) return;

    const saved = localStorage.getItem(`user_bookmark_${effectiveUserId}`);

    const isActive =
      saved === basePageName ||
      (saved && saved.startsWith(basePageName + "_"));

    setIsBookmarked(isActive);
    setBookmarkedValue(isActive ? saved : null);

    // Sync if storage changes in OTHER tabs only
    const handleStorage = (e) => {
      if (e.key !== `user_bookmark_${effectiveUserId}`) return;
      const updated = e.newValue;
      const active =
        updated === basePageName ||
        (updated && updated.startsWith(basePageName + "_"));
      setIsBookmarked(!!active);
      setBookmarkedValue(active ? updated : null);
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [effectiveUserId, basePageName]);

  const toggleBookmark = (extraValue = null) => {
    if (!effectiveUserId) {
      showToast("Please log in first", "error");
      return;
    }

    let newValue = basePageName;
    if (extraValue) {
      newValue = `${basePageName}_${extraValue}`;
    }

    const current = localStorage.getItem(`user_bookmark_${effectiveUserId}`);

    if (current === newValue) {
      localStorage.removeItem(`user_bookmark_${effectiveUserId}`);
      setIsBookmarked(false);
      setBookmarkedValue(null);
      showToast("Bookmark removed.", "info");
    } else {
      localStorage.setItem(`user_bookmark_${effectiveUserId}`, newValue);
      setIsBookmarked(true);
      setBookmarkedValue(newValue);
      showToast(
        `${basePageName.toUpperCase()} bookmarked! You will land here on next login.`,
        "success"
      );
    }

    // REMOVED: window.dispatchEvent(new Event('storage'))
    // Dispatching a synthetic storage event on the same tab triggers every
    // component listening to 'storage' (including dashboard.js), causing
    // unintended re-renders and silent navigation away from the current page.
    // The state above is already updated directly — no event needed same-tab.
  };

  return {
    isBookmarked,
    toggleBookmark,
    bookmarkedValue,
  };
};

export default useBookmark;